/* eslint-disable @typescript-eslint/no-explicit-any */
import goToProduct from '@/navigation/CSR/goToProduct'
import { useFiltersContext } from '@mercadoni/sinister/dist/cjs/filters/context'
import {
  useProductItemEvent,
  useViewItemList,
} from '@mercadoni/sinister/dist/cjs/monitors'
import { useHeaderDataContext } from '@mercadoni/sinister/dist/cjs/shared/contexts'
import { useRouter } from 'next/navigation'
import { useEffect } from 'react'

import { TRACK_SOURCE } from '../../utils/constants'

const ProductsLogic = ({ Wrapper }: any) => {
  const { products, filters, fetchMoreData, pagination } = useFiltersContext()
  const { sendViewItemListEvent } = useViewItemList()
  const { headerData } = useHeaderDataContext()
  const { searchTerm } = filters
  const searchCategory = { name: searchTerm }
  const router = useRouter()
  const { sendSelectProductEvent } = useProductItemEvent()

  useEffect(() => {
    if (!products?.length) return
    sendViewItemListEvent({
      type: 'search',
      category: {
        products,
        name: filters.searchTerm,
      },
      customParams: {
        screen_name: headerData?.screenName,
        url: window.location.href,
      },
      pagination,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [products])

  const onProductClick = (product: any) => {
    sendSelectProductEvent({
      trackSource: 'search',
      product,
    }),
      goToProduct(router, product.slug)
  }

  return (
    <Wrapper
      products={products}
      searchTerm={searchTerm}
      page={pagination.page}
      pages={pagination.pages}
      trackSource={TRACK_SOURCE}
      fetchMoreData={fetchMoreData}
      onProductClick={onProductClick}
      category={searchCategory}
    />
  )
}

export default ProductsLogic
